(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lev-vormerkung-form"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';
    if (window.__levVmInit) { return; }
    window.__levVmInit = true;

    function config() {
      var raw = window.LEV_KLAVIYO;
      if (!raw || typeof raw !== 'object' || !raw.companyId || !raw.listId) { return null; }
      return {
        companyId: raw.companyId,
        listId: raw.listId,
        apiBase: raw.apiBase || 'https://a.klaviyo.com',
        subscribePath: raw.subscribePath || '/client/subscriptions/',
        revision: raw.revision || '2025-04-15'
      };
    }

    // Nur Blogs aus dieser Liste werden benannt. Ein neuer Blog meldet sich als 'blogs',
    // nie unter einem geratenen oder fremden Namen (Toby WQ-562 Auflage 2,
    // Art. 5 Abs. 1 lit. d DSGVO). Stand 2026-09-15: der Shop hat genau diese zwei.
    var BLOGS = { ratgeber: 'blogs/ratgeber', news: 'blogs/news' };

    // Geschlossene Tabelle statt Rueckfall auf 'produkte': die Startseite meldete sich
    // frueher als pages/produkte, weil page.handle dort leer ist. Artikel- und
    // Blog-Seiten melden nur das Verzeichnis und tragen NIE den Artikel-Slug
    // (Toby WQ-547 Auflage c: keine Art-9-nahe Seitenangabe am Profil). Produkt- und
    // Kollektionsseiten melden nur die Gattung. Alles Unbekannte heisst 'unbekannt',
    // nie eine geratene Seite.
    function seite(box) {
      var t = box.getAttribute('data-template') || '';
      var h = box.getAttribute('data-seite') || '';
      var b = box.getAttribute('data-blog') || '';
      if (t === 'index') { return 'startseite'; }
      if (t === 'page') { return h ? 'pages/' + h : 'unbekannt'; }
      if (t === 'article' || t === 'blog') {
        return Object.prototype.hasOwnProperty.call(BLOGS, b) ? BLOGS[b] : 'blogs';
      }
      if (t === 'product') { return 'products'; }
      if (t === 'collection') { return 'collections'; }
      return 'unbekannt';
    }

    function subscribe(conf, email, box) {
      var wo = seite(box);
      var interesse = box.getAttribute('data-interesse') || 'protokoll';
      var props = {
        herkunft: 'product-waitlist',
        vormerkung: 'charge-1',
        einwilligung_fassung: box.getAttribute('data-fassung') || 'Wartelisten-Kaestchen v5, Stand 2026-09-14',
        quelle_seite: wo,
        produkt_interesse: interesse
      };
      // Eine Zeile je Transportweg, gleich wie in lev-klaviyo.js, lev-newsletter.liquid
      // und lev-blog-capture.liquid: kanal und quelle_methode kommen aus lev-source.js
      // (eigene, geschlossene Allowlist, disjunkt von den Feldern oben). Fehlt das Modul,
      // bleibt die Nutzlast unveraendert: eine Vormerkung scheitert nie an der Messung.
      if (window.LEV_SOURCE && typeof window.LEV_SOURCE.merge === 'function') {
        try { window.LEV_SOURCE.merge(props); } catch (e) { /* nie das Formular brechen */ }
      }
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'levanura.de/' + wo + ' Vormerkung ' + interesse,
            profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
          },
          relationships: { list: { data: { type: 'list', id: conf.listId } } }
        }
      };
      return window.fetch(conf.apiBase + conf.subscribePath + '?company_id=' + encodeURIComponent(conf.companyId), {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/vnd.api+json', revision: conf.revision },
        body: JSON.stringify(payload)
      });
    }

    function wire(box) {
      var form = box.querySelector('[data-lev-vm-form]');
      var fallback = box.querySelector('[data-lev-vm-fallback]');
      if (!form) { return; }
      form.hidden = false;
      if (fallback) { fallback.hidden = true; }
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var conf = config();
        if (!conf) { return; }
        var mail = form.querySelector('input[type=email]');
        var tick = form.querySelector('input[type=checkbox]');
        var err = form.querySelector('.lev-vm__fehler');
        var note = form.querySelector('.lev-vm__note');
        var btn = form.querySelector('button[type=submit]');
        var email = (mail && mail.value || '').trim();
        if (!email || email.indexOf('@') < 1 || !tick || !tick.checked) {
          if (err) { err.hidden = false; }
          return;
        }
        if (err) { err.hidden = true; }
        if (note) { note.hidden = false; }
        if (btn) { btn.disabled = true; }
        var done = function (ok) {
          if (ok) {
            form.hidden = true;
            var danke = box.querySelector('.lev-vm__danke');
            if (danke) { danke.hidden = false; }
            // WQ-1005: Signal fuer die Werbe-Messung (snippets/lev-ad-tags.liquid), ohne
            // Adresse und ohne Produktinteresse. Ohne Marketing-Einwilligung hoert niemand zu.
            try { document.dispatchEvent(new CustomEvent('lev:signup', { detail: { email: email } })); } catch (e) { /* nie das Formular brechen */ }
          } else {
            if (btn) { btn.disabled = false; }
            if (note) { note.hidden = true; }
          }
        };
        try {
          subscribe(conf, email, box)
            .then(function (resp) { done(!!(resp && resp.ok)); })
            ['catch'](function () { done(false); });
        } catch (e) { done(false); }
      });
    }

    function init() {
      if (!config()) { return; }
      var boxes = document.querySelectorAll('[data-lev-vm]');
      for (var i = 0; i < boxes.length; i++) { wire(boxes[i]); }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
